module.exports = __webpack_public_path__ + "img/mind.a6b61b0d.jpg";